import {
	Disclosure,
	DisclosureButton,
	DisclosurePanel,
	Menu,
	MenuButton,
	MenuItem,
	MenuItems,
} from "@headlessui/react";
import {
	Bars3Icon,
	BellIcon,
	XMarkIcon,
	QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import logo from "../assets/feapi.jpg";
import user from "../assets/user.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const navigation = [
	{ name: "Home", href: "/", current: true },

	/* { name: 'Dashboard', href: '#', current: true },
  { name: 'Team', href: '#', current: false },
  { name: 'Projects', href: '#', current: false },
  { name: 'Calendar', href: '#', current: false },*/
];

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

export default function Header() {
	const navigate = useNavigate();
	const [isNotif, setIsNotif] = useState(false);

	const notifications = [
		/*
    { id: 1, message: "Tienes una nueva reunión a las 10 AM" },
    { id: 2, message: "Pedido #1234 ha sido enviado" },
    { id: 3, message: "Nuevo comentario en tu publicación" },
     */
	];
	const logout = () => {
		// Lógica para cerrar sesión
		sessionStorage.clear();
		// Por ejemplo, puedes limpiar el estado de autenticación
		// y redirigir al usuario a la página de inicio de sesión
		navigate("/login");
	};

	return (
		<>
			<Disclosure as="nav" className="bg-gray-800">
				<div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
					<div className="relative flex h-16 items-center justify-between">
						<div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
							{/* Mobile menu button*/}
							<DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset">
								<span className="absolute -inset-0.5" />
								<span className="sr-only">Open main menu</span>
								<Bars3Icon
									aria-hidden="true"
									className="block size-6 group-data-open:hidden"
								/>
								<XMarkIcon
									aria-hidden="true"
									className="hidden size-6 group-data-open:block"
								/>
							</DisclosureButton>
						</div>
						<div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
							<div className="hidden sm:ml-6 sm:block">
								<div className="flex space-x-4">
									{navigation.map((item) => (
										<Link
											key={item.name}
											to={item.href} // Asegúrate de que `item.href` tiene la URL correcta
											className={classNames(
												item.current
													? "bg-gray-900 text-white"
													: "text-gray-300 hover:bg-gray-700 hover:text-white",
												"rounded-md px-3 py-2 text-sm font-medium",
											)}
											aria-current={item.current ? "page" : undefined}
										>
											{item.name}
										</Link>
									))}
								</div>
							</div>
						</div>
						<div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
							<div className="relative">
								<div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
									{/* Botón de Documentación */}
									<button
										type="button"
										onClick={() => navigate("/documentacion")}
										className="relative rounded-full bg-gray-800 p-2 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
									>
										<QuestionMarkCircleIcon className="size-6" />
									</button>

									{/* Botón de notificaciones */}
									<button
										type="button"
										onClick={() => setIsNotif((v) => !v)}
										className="relative ml-2 rounded-full bg-gray-800 p-2 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
									>
										<BellIcon className="size-6" />
										{notifications.length > 0 && (
											<span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
												{notifications.length}
											</span>
										)}
									</button>

									{/* Menú de notificaciones */}
									{isNotif && (
										<div className="absolute right-0 top-full z-50 mt-3 w-72 overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black/5">
											<div className="border-b px-4 py-3">
												<h3 className="text-sm font-semibold text-gray-800">
													Notificaciones
												</h3>
												<p className="text-xs text-gray-500">
													{notifications.length} nuevas
												</p>
											</div>

											<ul className="max-h-56 overflow-y-auto">
												{notifications.map((n) => (
													<li
														key={n.id}
														className="cursor-pointer px-4 py-3 text-sm text-gray-700 hover:bg-gray-50"
													>
														{n.message}
													</li>
												))}
											</ul>

											{notifications.length === 0 && (
												<p className="p-4 text-center text-sm text-gray-500">
													No hay notificaciones
												</p>
											)}
										</div>
									)}
								</div>
							</div>

							{/* Profile dropdown */}
							<Menu as="div" className="relative ml-3">
								<div>
									<MenuButton className="relative flex rounded-full bg-gray-800 text-sm focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 focus:outline-hidden">
										<span className="absolute -inset-1.5" />
										<span className="sr-only">Open user menu</span>
										<img alt="" src={user} className="size-8 rounded-full" />
									</MenuButton>
								</div>
								<MenuItems
									transition
									className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
								>
									<MenuItem>
										<a
											className="
												block px-4 py-2 text-sm text-gray-700
												data-[active]:bg-gray-100
												data-[active]:text-gray-900
												"
										>
											Your Profile
										</a>
									</MenuItem>

									<MenuItem>
										<a
											onClick={logout}
											className="
												block px-4 py-2 text-sm text-gray-700
												data-[active]:bg-gray-100
												data-[active]:text-gray-900
												cursor-pointer
												"
										>
											Sign out
										</a>
									</MenuItem>
								</MenuItems>
							</Menu>
						</div>
					</div>
				</div>

				<DisclosurePanel className="sm:hidden">
					<div className="space-y-1 px-2 pt-2 pb-3">
						{navigation.map((item) => (
							<DisclosureButton
								key={item.name}
								as="a"
								href={item.href}
								aria-current={item.current ? "page" : undefined}
								className={classNames(
									item.current
										? "bg-gray-900 text-white"
										: "text-gray-300 hover:bg-gray-700 hover:text-white",
									"block rounded-md px-3 py-2 text-base font-medium",
								)}
							>
								{item.name}
							</DisclosureButton>
						))}
					</div>
				</DisclosurePanel>
			</Disclosure>
		</>
	);
}
